import { GridColDef } from '@mui/x-data-grid';
import { renderPortfolioDetailsButton } from 'pages/PortfoliosPage/PortfolioTable/RenderPortfolioDetailsButton';


export const portfolioColumns: GridColDef[] = [
  { field: 'name', headerName: 'Portfolio Name', flex: 1 },
  { field: 'description', headerName: 'Description', flex: 1 },
  { field: 'type', headerName: 'Type', flex: 1 },
  {
    field: 'portfolioDetails',
    renderCell: renderPortfolioDetailsButton,
    headerName: 'Details',
    width: 85,
    align: 'center',
  },
];
